import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import { CodeActionType } from 'app/area/indicator-factors/item/types';

interface SaveButtonConfigInput {
  actionType: CodeActionType;
  shouldPrompt?: boolean;
  translation: CodetableTranslation;
}

interface SaveButtonConfigOutput {
  text: string;
  disabled?: boolean;
}

export const saveButtonConfig = (saveButtonConfigInput: SaveButtonConfigInput): SaveButtonConfigOutput => {

  const {
    actionType, shouldPrompt, translation: { add_code = '', update_code = '' } = {}
  } = saveButtonConfigInput ?? {};

  return {
    [CodeActionType.Add]: {
      text: add_code
    },
    [CodeActionType.Edit]: {
      text: update_code
    },
    [CodeActionType.Duplicate]: {
      text: update_code,
      disabled: !shouldPrompt
    }
  }[actionType];
};
